export { default as GiftModal } from './GiftModal'



// WEBPACK FOOTER //
// ./src/components/giftModal/index.js